module.exports = __webpack_public_path__ + "static/media/preview-campaign.cdb0c6d3.png";